import { Briefcase, CircuitBoard, Cpu, Wrench } from "lucide-react";

import { TEAM_DOMAIN_COLORS } from "@/constants/team";
import type { TeamDomainItem } from "@/types/domain";

export const TEAM_DOMAIN_ITEMS: TeamDomainItem[] = [
  { id: "software", icon: Cpu, color: TEAM_DOMAIN_COLORS.software },
  { id: "electrical", icon: CircuitBoard, color: TEAM_DOMAIN_COLORS.electrical },
  { id: "mechanical", icon: Wrench, color: TEAM_DOMAIN_COLORS.mechanical },
  { id: "business", icon: Briefcase, color: TEAM_DOMAIN_COLORS.business },
];
